import React from "react";
import { Redirect } from "react-router-dom";

import { URI_PATHS } from "../../../constants";

import Login from "../../login/Login";

const LoginV2 = () => {
  const jwt = localStorage.getItem("jwt");

  if(jwt)
    return <Redirect to={URI_PATHS.RESUME_APPLICATION} />;

  return <Login />;
};

export default LoginV2;